// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Future from "reason-future/src/Future.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Js_string from "rescript/lib/es6/js_string.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Js_promise from "rescript/lib/es6/js_promise.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_format from "rescript/lib/es6/caml_format.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as SLI$LiveRoom from "../../bindings/SLI.bs.js";
import * as GoTo$LiveRoom from "../../GoTo.bs.js";
import * as Amount$LiveRoom from "../../Amount.bs.js";
import * as Apollo$LiveRoom from "../../Apollo.bs.js";
import * as Config$LiveRoom from "../../../Config.bs.js";
import * as I18next$LiveRoom from "../../bindings/I18next.bs.js";
import * as PropSpread$LiveRoom from "../../components/PropSpread.bs.js";
import * as Utils_User$LiveRoom from "../../Utils/Utils_User.bs.js";
import * as Notification$LiveRoom from "../../components/Notification.bs.js";
import * as Utils_Mobile$LiveRoom from "../../Utils/Utils_Mobile.bs.js";
import * as AuthTokenHook$LiveRoom from "../../stores/AuthTokenHook.bs.js";
import * as Utils_Auction$LiveRoom from "../../Utils/Utils_Auction.bs.js";
import * as Utils_Logging$LiveRoom from "../../Utils/Utils_Logging.bs.js";
import * as SterlingTokens$LiveRoom from "../../bindings/SterlingTokens.bs.js";
import * as CustomerSession$LiveRoom from "./CustomerSession.bs.js";
import * as Button from "@sothebys/sterling/button";
import * as AnalyticsManager$LiveRoom from "../../analytics/AnalyticsManager.bs.js";
import * as ClientapiQueries$LiveRoom from "../../ClientapiQueries.bs.js";
import * as ActionNeededToBid$LiveRoom from "./ActionNeededToBid.bs.js";
import * as Utils_Breakpoints$LiveRoom from "../../Utils/Utils_Breakpoints.bs.js";
import * as Utils_IdRestriction$LiveRoom from "../../Utils/Utils_IdRestriction.bs.js";
import * as SlideToConfirm from "@sothebys/sterling/slide-to-confirm";

var fallbackBidState = {
  __typename: "BidState",
  id: "BidStateId",
  isClosed: true,
  bidAsk: "0",
  bidType: {
    NAME: "LiveBidType",
    VAL: {
      __typename: "LiveBidType",
      liveBidPhase: "Closed"
    }
  },
  sold: undefined
};

function getPlaceBidButtonState(socketConnected, bidPhase, latestBid, isPremiumLot, userIsPremiumLotWhitelisted, isLotWithdrawn, lotClosed, isInUpcomingSession) {
  if (!socketConnected || isPremiumLot && !userIsPremiumLotWhitelisted || isLotWithdrawn || lotClosed || bidPhase === "ConfirmingResult" || bidPhase === "Closed") {
    return true;
  } else if (bidPhase === "AcceptingBids") {
    if (isInUpcomingSession) {
      return false;
    } else {
      return true;
    }
  } else if (bidPhase === "Live") {
    if (latestBid !== undefined && !(latestBid === "ReserveNotMet" || latestBid === "BidAheadOfYou" || latestBid === "Cancelled" || latestBid === "Outbid")) {
      if (latestBid === "CurrentBid" || latestBid === "Lost" || latestBid === "Won" || latestBid === "MaxBid") {
        return true;
      } else {
        return latestBid === "Absentee";
      }
    } else {
      return false;
    }
  } else {
    return true;
  }
}

function getNavButtonState(t, socketConnected, isAuthenticated, paddleId, isInUpcomingSession) {
  if (socketConnected) {
    if (isAuthenticated) {
      if (Belt_Option.isNone(paddleId)) {
        return [
                false,
                Curry._1(t, "RegisterToBid")
              ];
      } else if (isInUpcomingSession) {
        return [
                false,
                Curry._1(t, "FeedButton_placeBid")
              ];
      } else {
        return [
                true,
                Curry._1(t, "FeedButton_placeBid")
              ];
      }
    } else {
      return [
              false,
              Curry._1(t, "FeedButton_loginToPlaceABid")
            ];
    }
  } else {
    return [
            true,
            Curry._1(t, "FeedButton_connectingToSocket")
          ];
  }
}

function PlaceBidButton$NavButton(props) {
  var saleNumber = props.saleNumber;
  var idCheck = props.idCheck;
  var enrollmentStatus = props.enrollmentStatus;
  var me = props.me;
  var auctionSlug = props.auctionSlug;
  var trackLoginToBid = props.trackLoginToBid;
  var isInUpcomingSession = props.isInUpcomingSession;
  var match = I18next$LiveRoom.useTranslation(undefined);
  var match$1 = getNavButtonState(match.t, props.socketConnected, props.isAuthenticated, props.paddleId, isInUpcomingSession);
  return React.createElement(PropSpread$LiveRoom.make, {
              data: {
                hd: {
                  TAG: /* TestId */1,
                  _0: "placeBidButton"
                },
                tl: /* [] */0
              },
              children: React.createElement(Button.Button, {
                    onClick: (function (param) {
                        var match = CustomerSession$LiveRoom.sessionStatus(me, enrollmentStatus);
                        if (typeof match === "number") {
                          if (match !== 0) {
                            return Curry._1(idCheck, undefined);
                          } else {
                            Curry._1(trackLoginToBid, undefined);
                            return AuthTokenHook$LiveRoom.triggerTransactionalUpgrade({
                                        showVerifyAccount: true,
                                        origin: /* PlaceBid */0,
                                        saleNumber: saleNumber
                                      }, {
                                        showSelectAccount: true
                                      }, Config$LiveRoom.values.transactionlUrl);
                          }
                        } else if (isInUpcomingSession) {
                          return GoTo$LiveRoom.auctionDetails(Utils_Auction$LiveRoom.getAuctionUrl(auctionSlug.name, auctionSlug.year, undefined, undefined));
                        } else {
                          return Curry._1(idCheck, undefined);
                        }
                      }),
                    disabled: match$1[0],
                    children: match$1[1]
                  })
            });
}

var NavButton = {
  getNavButtonState: getNavButtonState,
  make: PlaceBidButton$NavButton
};

function PlaceBidButton$BidButton(props) {
  var setModalToShow = props.setModalToShow;
  var trackBidPlaced = props.trackBidPlaced;
  var idCheck = props.idCheck;
  var nextBidCurrency = props.nextBidCurrency;
  var nextBidAsk = props.nextBidAsk;
  var enrollmentStatus = props.enrollmentStatus;
  var me = props.me;
  var lotId = props.lotId;
  var auctionId = props.auctionId;
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t = match.t;
  var match$1 = Curry.app(ClientapiQueries$LiveRoom.PlaceBidButton.PlaceBidMutation.use, [
        undefined,
        undefined,
        undefined,
        /* All */2,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined
      ]);
  var bidResult = match$1[1];
  var placeBidFn = match$1[0];
  var match$2 = React.useState(function () {
        
      });
  var setBidAmountInFlight = match$2[1];
  var match$3 = React.useState(function () {
        
      });
  var setSlideNextBidAsk = match$3[1];
  var nextBidAskWithSlide = Belt_Option.getWithDefault(match$3[0], nextBidAsk);
  var handlePlaceBid = function (param) {
    var match = CustomerSession$LiveRoom.sessionStatus(me, enrollmentStatus);
    if (typeof match === "number") {
      return Curry._1(idCheck, undefined);
    } else {
      Curry._1(setBidAmountInFlight, (function (param) {
              return nextBidAskWithSlide;
            }));
      Js_promise.then_((function (res) {
              if (res.TAG === /* Ok */0) {
                var match = res._0.data.placeLiveBid;
                if (match === "BidBlocked") {
                  Curry._1(setModalToShow, (function (param) {
                          return /* BidBlockModal */1;
                        }));
                } else if (match === "BidPlaced") {
                  Curry._1(trackBidPlaced, "BidIsWithYou");
                } else if (match === "BidBelowHighBid" || match === "BidBelowCurrentBid") {
                  Curry._1(trackBidPlaced, "BidTooLow");
                  Notification$LiveRoom.showError("BidIsTooLow");
                  Curry._1(setBidAmountInFlight, (function (param) {
                          
                        }));
                }
                SLI$LiveRoom.send("Good", undefined, "PlaceBid");
              } else {
                var match$1 = res._0;
                var networkError = match$1.networkError;
                var graphQLErrors = match$1.graphQLErrors;
                if (Belt_Array.some(graphQLErrors, (function (error) {
                          return Js_string.includes("User is not allowed to bid on lot", error.message);
                        }))) {
                  Curry._1(setModalToShow, (function (param) {
                          return /* BidBlockModal */1;
                        }));
                } else if (networkError !== undefined) {
                  Curry._1(trackBidPlaced, "ConnectionError");
                  Notification$LiveRoom.showError({
                        NAME: "PlaceBidError",
                        VAL: undefined
                      });
                  Utils_Logging$LiveRoom.log(Caml_option.some(Js_dict.fromList({
                                hd: [
                                  "__MODULE__",
                                  "PlaceBidButton-LiveRoom"
                                ],
                                tl: {
                                  hd: [
                                    "error",
                                    Belt_Option.getWithDefault(JSON.stringify(networkError), "")
                                  ],
                                  tl: /* [] */0
                                }
                              })), undefined, undefined, "Network error when placing bid");
                  SLI$LiveRoom.send("Bad", undefined, "PlaceBid");
                } else {
                  Notification$LiveRoom.showError({
                        NAME: "PlaceBidError",
                        VAL: Belt_Option.map(Belt_Array.get(graphQLErrors, 0), Apollo$LiveRoom.getErrorMessage)
                      });
                  Utils_Logging$LiveRoom.log(Caml_option.some(Js_dict.fromList({
                                hd: [
                                  "__MODULE__",
                                  "PlaceBidButton-LiveRoom"
                                ],
                                tl: {
                                  hd: [
                                    "error",
                                    Belt_Option.getWithDefault(JSON.stringify(graphQLErrors), "")
                                  ],
                                  tl: /* [] */0
                                }
                              })), undefined, undefined, "Unknown error when placing bid");
                  SLI$LiveRoom.send("Bad", undefined, "PlaceBid");
                }
              }
              return Promise.resolve(bidResult);
            }), Curry._8(placeBidFn, undefined, undefined, undefined, undefined, undefined, undefined, undefined, Curry._4(ClientapiQueries$LiveRoom.PlaceBidButton.PlaceBidMutation.makeVariables, auctionId, lotId, nextBidAskWithSlide, undefined)));
      return ;
    }
  };
  React.useEffect((function () {
          Curry._1(setBidAmountInFlight, (function (param) {
                  
                }));
        }), [
        nextBidAskWithSlide,
        bidResult.error
      ]);
  var nextBidFormatted = Amount$LiveRoom.format(nextBidAskWithSlide);
  var isButtonDisabled = props.isBidCapReached && Belt_Option.isSome(props.paddleId) || props.buttonDisabled || bidResult.loading || Belt_Option.isSome(match$2[0]);
  var isTouchDevice = React.useMemo((function () {
          return Utils_Mobile$LiveRoom.isTouchDevice(undefined);
        }), []);
  var breakpoint = Utils_Breakpoints$LiveRoom.useBreakpoint(undefined);
  var showSlideToBid = isTouchDevice && breakpoint !== /* Desktop */0;
  React.useEffect((function () {
          if (showSlideToBid && (breakpoint === /* Mobile */1 || breakpoint === /* TabletPortraitAndMobile */2)) {
            Curry._2(Css.$$global, ".ot-floating-button", {
                  hd: Css.important(Css.bottom(Css.px(64))),
                  tl: /* [] */0
                });
          }
          
        }), [
        showSlideToBid,
        breakpoint
      ]);
  if (showSlideToBid) {
    return React.createElement(SlideToConfirm.Button, {
                onSlide: (function (param) {
                    handlePlaceBid(undefined);
                  }),
                disabled: isButtonDisabled,
                className: isButtonDisabled ? Curry._1(Css.style, {
                        hd: Css.hover({
                              hd: Css.cursor("default"),
                              tl: /* [] */0
                            }),
                        tl: {
                          hd: Css.backgroundColor(Css.hex(SterlingTokens$LiveRoom.Colors.primaryNavy40_nohashtag)),
                          tl: {
                            hd: Css.borderStyle("none"),
                            tl: /* [] */0
                          }
                        }
                      }) : "",
                children: "" + Curry._1(t, "FeedButton_slideToPlaceBid") + " | " + nextBidFormatted + " " + nextBidCurrency + "",
                onSlideStart: (function (param) {
                    Curry._1(setSlideNextBidAsk, (function (param) {
                            return nextBidAsk;
                          }));
                  }),
                onSlideCancel: (function (param) {
                    Curry._1(setSlideNextBidAsk, (function (param) {
                            
                          }));
                  })
              });
  } else {
    return React.createElement(PropSpread$LiveRoom.make, {
                data: {
                  hd: {
                    TAG: /* TestId */1,
                    _0: "placeBidAndValueButton"
                  },
                  tl: /* [] */0
                },
                children: React.createElement(Button.Button, {
                      onClick: (function (param) {
                          handlePlaceBid(undefined);
                        }),
                      className: isButtonDisabled ? Curry._1(Css.style, {
                              hd: Css.hover({
                                    hd: Css.cursor("default"),
                                    tl: /* [] */0
                                  }),
                              tl: {
                                hd: Css.backgroundColor(Css.hex(SterlingTokens$LiveRoom.Colors.primaryNavy40_nohashtag)),
                                tl: {
                                  hd: Css.borderStyle("none"),
                                  tl: /* [] */0
                                }
                              }
                            }) : "",
                      disabled: isButtonDisabled,
                      loading: bidResult.loading,
                      children: "" + Curry._1(t, "FeedButton_placeBid") + " | " + nextBidFormatted + " " + nextBidCurrency + ""
                    })
              });
  }
}

var BidButton = {
  make: PlaceBidButton$BidButton
};

function PlaceBidButton(props) {
  var showSubmitIdentificationModal = props.showSubmitIdentificationModal;
  var showIncompleteRegistrationModal = props.showIncompleteRegistrationModal;
  var socketConnected = props.socketConnected;
  var showSelectAccountModal = props.showSelectAccountModal;
  var authToken = props.authToken;
  var lotFragment = props.lotFragment;
  var auctionFragment = props.auctionFragment;
  var match = React.useState(function () {
        return /* NoModal */0;
      });
  var setModalToShow = match[1];
  var isAuthenticated = typeof authToken === "object" ? authToken.NAME === "Authenticated" : false;
  var isTransactional = typeof authToken === "object" && authToken.NAME === "Authenticated" ? authToken.VAL.details.userType === "transactional" : false;
  var auctionId = auctionFragment.auctionId;
  var lotId = lotFragment.lotId;
  var bidState = Belt_Option.getWithDefault(lotFragment.bidState, fallbackBidState);
  var isInUpcomingSession = Belt_Option.mapWithDefault(lotFragment.session, false, (function (session) {
          return session.state.state === "PreOpen";
        }));
  var match$1 = bidState.bidType;
  var tmp;
  if (typeof match$1 === "object" && match$1.NAME === "LiveBidType") {
    var nextBidAsk = Belt_Option.getWithDefault(bidState.bidAsk, "0");
    var nextBidAmount = Caml_format.int_of_string(nextBidAsk);
    var sapAuctionSaleNumber = auctionFragment.sapSaleNumber;
    var departmentNames = Belt_List.fromArray(auctionFragment.departmentNames);
    var auctionName = auctionFragment.title;
    var lotTitle = lotFragment.title;
    var match$2 = lotFragment.lotNumber;
    var lotNr = typeof match$2 === "object" && match$2.NAME === "VisibleLotNumber" ? Caml_format.int_of_string(match$2.VAL.lotNumber) : undefined;
    var isPremiumLot = Utils_User$LiveRoom.shouldDisplayPremiumLotBanner(authToken, lotFragment.premiumLotState.isPremium);
    var match$3 = Belt_Option.flatMap(auctionFragment.enrollment.result, (function (result) {
            return result.enrollmentResult;
          }));
    var paddleId = match$3 !== undefined && typeof match$3 === "object" && match$3.NAME === "EnrollmentAccepted" ? Caml_format.int_of_string(match$3.VAL.paddleId) : undefined;
    var currency = auctionFragment.currency;
    var enrollmentStatus = Belt_Option.flatMap(auctionFragment.enrollment.result, (function (result) {
            return result.enrollmentResult;
          }));
    var me = {
      paddleId: paddleId,
      authToken: authToken,
      transactional: isTransactional
    };
    var buttonDisabled = getPlaceBidButtonState(socketConnected, match$1.VAL.liveBidPhase, Belt_Option.map(lotFragment.latestBid.bid, (function (x) {
                return x.bidState;
              })), isPremiumLot, lotFragment.premiumLotState.userIsWhitelisted, lotFragment.withdrawnState.state === "Withdrawn", bidState.isClosed, isInUpcomingSession);
    var match$4 = CustomerSession$LiveRoom.sessionStatus(me, enrollmentStatus);
    var showPlaceBidButton;
    var exit = 0;
    if (typeof match$4 === "number") {
      if (match$4 !== 0 || !isInUpcomingSession) {
        exit = 1;
      } else {
        showPlaceBidButton = false;
      }
    } else if (isInUpcomingSession) {
      showPlaceBidButton = false;
    } else {
      exit = 1;
    }
    if (exit === 1) {
      showPlaceBidButton = Belt_Option.isNone(paddleId) ? false : isAuthenticated;
    }
    var idCheck = function (param) {
      Future.get(Utils_IdRestriction$LiveRoom.checkForId(undefined, me, undefined), (function (res) {
              var status = res.status;
              if (status !== 0) {
                if (status >= 5) {
                  return ;
                } else {
                  return Curry._1(showSubmitIdentificationModal, status);
                }
              }
              var match = CustomerSession$LiveRoom.sessionStatus(me, enrollmentStatus);
              if (typeof match !== "number") {
                return ;
              }
              switch (match) {
                case /* NotLoggedIn */0 :
                    return ;
                case /* AuthenticatedBasicUser */1 :
                    AnalyticsManager$LiveRoom.loginToBid(sapAuctionSaleNumber, departmentNames, auctionId, auctionName, lotId, lotTitle, lotNr);
                    return AuthTokenHook$LiveRoom.triggerTransactionalUpgrade({
                                showVerifyAccount: true,
                                origin: /* PlaceBid */0,
                                saleNumber: sapAuctionSaleNumber
                              }, {
                                showSelectAccount: true
                              }, Config$LiveRoom.values.transactionlUrl);
                case /* NotRegisteredToBid */2 :
                    return Curry._1(showSelectAccountModal, undefined);
                case /* RegistrationIncomplete */3 :
                    AnalyticsManager$LiveRoom.actionNeededPendingEnrollmentViewed(sapAuctionSaleNumber, lotNr, "LiveRoom", nextBidAmount, Amount$LiveRoom.currencyToString(currency), "ActionNeededToBid");
                    return Curry._1(showIncompleteRegistrationModal, undefined);
                
              }
            }));
    };
    tmp = showPlaceBidButton ? React.createElement(PlaceBidButton$BidButton, {
            buttonDisabled: buttonDisabled,
            auctionId: auctionId,
            lotId: lotId,
            paddleId: paddleId,
            me: me,
            isBidCapReached: props.isBidCapReached,
            enrollmentStatus: enrollmentStatus,
            nextBidAsk: nextBidAsk,
            nextBidCurrency: Amount$LiveRoom.currencyToString(currency),
            idCheck: idCheck,
            trackBidPlaced: (function (bidResult) {
                AnalyticsManager$LiveRoom.bidPlaced(nextBidAmount, bidResult, auctionId, auctionName, departmentNames, Amount$LiveRoom.currencyToString(currency), sapAuctionSaleNumber, lotId, lotNr, lotTitle, "Live");
              }),
            setModalToShow: setModalToShow
          }) : React.createElement(PlaceBidButton$NavButton, {
            socketConnected: socketConnected,
            isAuthenticated: isAuthenticated,
            paddleId: paddleId,
            isInUpcomingSession: isInUpcomingSession,
            trackLoginToBid: (function (param) {
                AnalyticsManager$LiveRoom.loginToBid(sapAuctionSaleNumber, departmentNames, auctionId, auctionName, lotId, lotTitle, lotNr);
              }),
            auctionSlug: auctionFragment.slug,
            me: me,
            enrollmentStatus: enrollmentStatus,
            idCheck: idCheck,
            saleNumber: sapAuctionSaleNumber
          });
  } else {
    tmp = null;
  }
  return React.createElement(React.Fragment, undefined, tmp, match[0] ? React.createElement(ActionNeededToBid$LiveRoom.make, {
                    onClose: (function (param) {
                        Curry._1(setModalToShow, (function (param) {
                                return /* NoModal */0;
                              }));
                      })
                  }) : null);
}

var PremiumLotStateFragment = ClientapiQueries$LiveRoom.PlaceBidButton.PremiumLotStateFragment;

var SessionStateFragment = ClientapiQueries$LiveRoom.PlaceBidButton.SessionStateFragment;

var AuctionBaseEnrollmentResultFragment = ClientapiQueries$LiveRoom.PlaceBidButton.AuctionBaseEnrollmentResultFragment;

var PlaceBidUserBidConnectionFragment = ClientapiQueries$LiveRoom.PlaceBidButton.PlaceBidUserBidConnectionFragment;

var PlaceBidBidStateFragment = ClientapiQueries$LiveRoom.PlaceBidButton.PlaceBidBidStateFragment;

var PlaceBidButtonAuctionFragment = ClientapiQueries$LiveRoom.PlaceBidButton.PlaceBidButtonAuctionFragment;

var PlaceBidButtonLotFragment = ClientapiQueries$LiveRoom.PlaceBidButton.PlaceBidButtonLotFragment;

var PlaceBidMutation = ClientapiQueries$LiveRoom.PlaceBidButton.PlaceBidMutation;

var makeUserBidConnectionFragment = ClientapiQueries$LiveRoom.PlaceBidButton.makeUserBidConnectionFragment;

var defaultLotNumber = ClientapiQueries$LiveRoom.PlaceBidButton.defaultLotNumber;

var defaultPremiumLotState = ClientapiQueries$LiveRoom.PlaceBidButton.defaultPremiumLotState;

var defaultWithdrawnState = ClientapiQueries$LiveRoom.PlaceBidButton.defaultWithdrawnState;

var makeLotFragment = ClientapiQueries$LiveRoom.PlaceBidButton.makeLotFragment;

var make = PlaceBidButton;

export {
  PremiumLotStateFragment ,
  SessionStateFragment ,
  AuctionBaseEnrollmentResultFragment ,
  PlaceBidUserBidConnectionFragment ,
  PlaceBidBidStateFragment ,
  PlaceBidButtonAuctionFragment ,
  PlaceBidButtonLotFragment ,
  PlaceBidMutation ,
  makeUserBidConnectionFragment ,
  defaultLotNumber ,
  defaultPremiumLotState ,
  defaultWithdrawnState ,
  makeLotFragment ,
  fallbackBidState ,
  getPlaceBidButtonState ,
  NavButton ,
  BidButton ,
  make ,
}
/* Css Not a pure module */
